import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { ServiceBaseService } from 'projects/shared/src/lib/services/service-base.service';

import * as Sentry from '@sentry/angular-ivy';

if (
    ServiceBaseService.getEnvironment.indexOf('prod') > -1 ||
    localStorage.getItem('isSentryLogEnabled') == '1'
) {
    Sentry.init({
        dsn: 'https://6464c0d2aa8941f28378559ba4d35d1f@o4504877451182080.ingest.sentry.io/4505442448965632',
        release: 'provider-manager-V1.0',
        tracesSampleRate: 0.2,
        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        //replaysSessionSampleRate: 0.1,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        //replaysOnErrorSampleRate: 1.0,
        environment: ServiceBaseService.getEnvironment,
        integrations: [
            new Sentry.BrowserTracing({
                tracePropagationTargets: [
                    'http://localhost:5009/',
                    'http://localhost:4200/',
                    'https://provider-manager.roksh.com',
                    'https://provider-manager.roksh.at',
                ],
                routingInstrumentation: Sentry.routingInstrumentation,
            }),
            new Sentry.Integrations.Breadcrumbs({
                console: false,
            }),
        ],
    });
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
